<template>

    <div>

        <div class="row row-cols-1 row-cols-lg-2 g-4">

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Synonyms') }}</legend>
                            <div v-for="(term, index) in form.terms" class="row align-items-center">
                                <div class="col-10">
                                    <text-input
                                        v-model="form.terms[index]"
                                        :placeholder="__('Term')"
                                        :error="form.errors[`terms.${index}`]"/>
                                </div>
                                <div class="col-2">
                                    <button type="button" class="btn btn-outline-danger" @click="removeTerm(index)"
                                            v-if="index > 0">
                                        {{ __('Löschen') }}
                                    </button>
                                </div>
                            </div>
                            <button type="button" class="btn btn-outline-primary" @click="addTerm()">
                                {{ __('Add') }}
                            </button>
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Misc') }}</legend>
                            <textarea-input label="notes" v-model="form.notes" :error="form.errors.notes" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center w-100">
                <submit-button :form="form" />
                <button type="button" class="btn link-danger" @click="destroy" v-if="synonym">
                    {{ __('Löschen') }}
                </button>
            </div>

        </div>

    </div>

</div>

</div>
</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'form',
            'synonym',
        ],
        data() {
            return {

            }
        },
        components: {
            TextInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            SubmitButton,
        },
        watch: {
        },
        methods: {
            addTerm() {

                if (this.form.terms.length >= 100) {
                    alert('Sie können maximal 100 Synonyme angeben.');
                    return false;
                }

                const term = '';
                this.form.terms.push(term);
            },
            removeTerm(index) {
                Vue.delete(this.form.terms, index);
            },
            destroy() {
                if (confirm(this.__('Sind Sie sicher?'))) {
                    this.$inertia.delete(this.route('admin.synonyms.destroy', this.synonym));
                }
            },
        },
    }
</script>
